import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../../hooks/useAuth";
import Avatar from "@mui/material/Avatar";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import LogoutIcon from "@mui/icons-material/Logout";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import "./useravatarmenu.css";

import { useNavigate } from "react-router-dom";

const UserAvatarMenu = () => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const { user, logout } = useAuth();
  const isAdmin =
    user?.role === "admin" ||
    user?.roles?.includes?.("admin") ||
    user?.isAdmin === true;

  const getInitials = (name) =>
    name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2) || "U";
  const getFirstTwoParts = (name) => {
    const parts = name.split(" ");

    if (parts.length < 2) {
      return parts[0] || "";
    }
    return parts[0] + " " + parts[1];
  };

  useEffect(() => {
    const onOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };
    const onEsc = (e) => e.key === "Escape" && setShowMenu(false);

    document.addEventListener("pointerdown", onOutside, true);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("pointerdown", onOutside, true);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  const baseMenuItems = [
    {
      label: "Live",
      link: "/live",
      icon: <LiveTvIcon fontSize="small" />,
      className: "mobile-only-menu-item",
    },
    {
      label: "Library",
      link: "/library",
      icon: <LibraryBooksIcon fontSize="small" />,
      className: "mobile-only-menu-item",
    },
    {
      label: "Settings",
      link: "/settings",
      icon: <ManageAccountsIcon fontSize="small" />,
    },

    { label: "Logout", onClick: logout, icon: <LogoutIcon fontSize="small" /> },
  ];

  const menuItems = isAdmin
    ? [
        ...baseMenuItems.slice(0, 3), // Live, Library, Settings
        {
          label: "Admin Panel",
          link: "/admin",
          icon: <AdminPanelSettingsIcon fontSize="small" />,
        },
        ...baseMenuItems.slice(3), // Reset Password, Logout
      ]
    : baseMenuItems;

  return (
    <div className="app__useravatarmenu" ref={menuRef}>
      {user?.picture ? (
        <Avatar
          src={user.picture}
          alt={user.name}
          onClick={() => setShowMenu(!showMenu)}
          sx={{
            width: 40,
            height: 40,
            cursor: "pointer",
            "&:hover": {
              opacity: 0.8,
            },
          }}
        />
      ) : (
        <Avatar
          onClick={() => setShowMenu(!showMenu)}
          sx={{
            bgcolor: "#F58020",
            width: 40,
            height: 40,
            cursor: "pointer",
            "&:hover": {
              opacity: 0.8,
            },
          }}
        >
          {getInitials(user?.name)}
        </Avatar>
      )}
      {showMenu && (
        <div className="app__useravatarmenu-container scale-up-center">
          <div className="app__useravatarmenu-container-profile">
            <div className="app__useravatarmenu-container-profile-image">
              {user?.picture ? (
                <Avatar
                  src={user.picture}
                  alt={user.name}
                  onClick={() => setShowMenu(!showMenu)}
                  sx={{
                    width: 30,
                    height: 30,
                  }}
                />
              ) : (
                <Avatar
                  onClick={() => setShowMenu(!showMenu)}
                  sx={{
                    bgcolor: "#F58020",
                    fontSize: 14,
                    width: 30,
                    height: 30,
                  }}
                >
                  {getInitials(user?.name)}
                </Avatar>
              )}
            </div>
            <div
              className="app__useravatarmenu-container-profile-content"
              onClick={() => {
                setShowMenu(false); // close dropdown
                navigate("/profile"); // then navigate
              }}
            >
              <p>{getFirstTwoParts(user.name)}</p>
              <p>View Profile</p>
            </div>
          </div>

          <div className="app__useravatarmenu-container-divider"></div>
          {menuItems.map((item, index) => (
            <React.Fragment key={item.label}>
              <div
                className={`app__useravatarmenu-container-item ${
                  item.className || ""
                }`}
                onClick={item.onClick}
              >
                <p className="app__useravatarmenu-container-item-icon">
                  {item.icon}
                </p>
                {item.link ? (
                  <a href={item.link}>{item.label}</a>
                ) : (
                  <span>{item.label}</span>
                )}
              </div>
              {index !== menuItems.length - 1 && (
                <div className="app__useravatarmenu-container-divider"></div>
              )}
            </React.Fragment>
          ))}
        </div>
        // <div className="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
        //   <div className="py-2 px-4 border-b border-gray-100">
        //     <p className="text-sm font-medium text-gray-900">{user?.name}</p>
        //     <p className="text-sm text-gray-500">{user?.email}</p>
        //   </div>
        //   <div className="py-1">
        //     {menuItems.map((item, index) =>
        //       item.onClick ? (
        //         <button
        //           key={index}
        //           onClick={item.onClick}
        //           className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
        //         >
        //           {item.label}
        //         </button>
        //       ) : (
        //         <a
        //           key={index}
        //           href={item.link}
        //           className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
        //         >
        //           {item.label}
        //         </a>
        //       )
        //     )}
        //   </div>
        // </div>
      )}
    </div>
  );
};

export default UserAvatarMenu;
